import type * as im from "immutable";

import { type ValuePath } from "./ValuePath";

/**
 * A simple React state wrapper that helps track which fields are expanded in the value inspector.
 */
export class ExpandedFieldStateManager {
	private readonly _expanded: im.Map<string, ValuePath>;
	private readonly _setExpanded: (expanded: im.Map<string, ValuePath>) => void;

	constructor(
		reactExpandedFieldsState: [
			im.Map<string, ValuePath>,
			React.Dispatch<React.SetStateAction<im.Map<string, ValuePath>>>,
		]
	) {
		[this._expanded, this._setExpanded] = reactExpandedFieldsState;
	}

	expanded(path: ValuePath) {
		return this._expanded.has(toCanonicalString(path));
	}

	expand(path: ValuePath) {
		this._setExpanded(this._expanded.set(toCanonicalString(path), path));
	}

	collapse(path: ValuePath) {
		this._setExpanded(this._expanded.delete(toCanonicalString(path)));
	}
}

function toCanonicalString(path: ValuePath) {
	const joining = [path[0].cellName];
	for (let i = 1; i < path.length; i++) {
		const curr = path[i];
		switch (curr?.type) {
			case "ObjectField":
			case "ArrayElement":
			case "MapField":
				// TODO: This won't work for Map keys that are not stringable.
				joining.push(String(curr.key));
				break;

			case "SetField":
				joining.push(JSON.stringify(curr.index));
				break;

			default:
				throw new Error("not implemented");
		}
	}

	return joining.join(",");
}
